/*
 * @Author: fanxiaoning
 * @Date: 2022-08-05 11:20:57
 * @LastEditors: xuhongwei
 * @LastEditTime: 2023-03-30 11:48:42
 */
// import "core-js/stable";
// import "regenerator-runtime/runtime";
// import "babel-polyfill";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./global.scss";
// import "./common.scss";
// import eruda from "eruda";
import VueMeta from "vue-meta";
import Vant from "vant";
import "@vant/touch-emulator";
import "vant/lib/index.less";
import "@/utils/androidInput";
import "@/utils/directives";
import * as filters from "./filters/index";
import vSelect from "vue-select";
// import { Table } from "view-design";
// import "view-design/dist/styles/iview.css";
// import "swiper/swiper-bundle.css";
import i18n from "./locales";

Vue.config.productionTip = false;

// Vue.component("Table", Table);
Vue.component("v-select", vSelect);
import { statistics, utils } from "msb-public-library";
import { ReportLog } from "@msb-next/report-log";

// 初始化日志上报
// new ReportLog({
//   project: "msb-1v1-h5-" + import.meta.env.VITE_APP_ENV, // 必填 应用名称，取项目名即可
//   logging: false, // 选填 是否打印上传成功的日志，默认打印
//   cdn: {
//     socket: "https://imgvip.meishubao.com/js/socket.io.min.js",
//     protobuf: "https://imgvip.meishubao.com/js/protobuf.min.js"
//   }, // 选填 自定义socket和protobuf的cdn源，默认官方源
//   url: "https://support-test.meishubao.com/" // 选填 上报地址，默认/
//   // transports: ['websocket'] // 选填 更改上报socket连接方式，默认websocket
// });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

Vue.use(Vant);
Vue.config.productionTip = false;

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Object.keys(filters).forEach(key => {
  //@ts-ignore
  Vue.filter(key, filters[key]);
});

if (utils.client.android) {
  // 安卓会在页面即将关闭时调用onClose事件，需注册。
  window.onClose = function () {};
}

// if (
//   import.meta.env.VITE_APP_ENV === "live" ||
//   import.meta.env.VITE_APP_ENV === "gray" ||
//   import.meta.env.VITE_APP_ENV === "test"
// ) {
//   statistics({
//     type: "baidu",
//     id: "0fde7dfaddb9dba51f6341584784fccd"
//   });

//   const type = "mta";
//   const id = "500710860";
//   const cid = "500710863";

//   statistics({ type, id, cid });
// }

if (import.meta.env.VITE_APP_ENV !== "live") {
  utils
    .loadScript(
      "https://imgvip.meishubao.com/vip/codeMovie/msb-1v1-newh5/online/js/eruda.min.js"
    )
    .then(() => {
      eruda.init();
    });
}

console.log("🚀 ~ main.ts:101 ~ i18n.locale:", i18n.locale)
